import Vue from 'vue'
import Router from '../../router'
import { TREATMENT_PAGE_VIEWS, ROUTES } from '../../const'

export default {
    namespaced: true,
    state: () => ({
        previousPageName: null,
        currentView: null,
        previousTreatmentView: null,
        selectedHelpCenterTab: 'videos'
    }),
    getters: {},
    mutations: {
        setPreviousPageName(state, pageName) {
            state.previousPageName = pageName
        },
        currentTreatmentView(state, view) {
            state.currentView = view
        },
        previousTreatmentView(state, view) {
            state.previousTreatmentView = view
        }
    },
    actions: {
        switchTreatmentView({ state, commit }, view) {
            Vue.$log.navigationEvent('goto_' + view)

            if (state.currentView !== view) {
                commit('previousTreatmentView', state.currentView)
                commit('currentTreatmentView', view)
            }
        },
        navigateToTreatment({ dispatch }, { patientId, treatmentId, slideId, view }) {
            dispatch('onBeforeNavigate')

            Router.push({
                name: ROUTES.TREATMENTS,
                params: {
                    patient_id: patientId,
                    treatment_id: treatmentId
                },
                query: {
                    slide_id: encodeURIComponent(slideId),
                    view: view || TREATMENT_PAGE_VIEWS.WELL_CARDS
                }
            }).catch(err => {
                console.warn(err)
            })
        },
        navigateToWell({ dispatch }, { patientId, treatmentId, wellId }) {
            dispatch('onBeforeNavigate')

            Router.push({
                name: ROUTES.WELL,
                params: {
                    patient_id: patientId,
                    treatment_id: treatmentId,
                    well_id: wellId
                }
            }).catch(err => {
                console.warn(err)
            })
        },
        navigateToHelpCenter({ dispatch }) {
            Vue.$log.navigationEvent('goto_tutorials_page')

            dispatch('onBeforeNavigate')

            Router.push({
                name: ROUTES.HELP_CENTER
            }).catch(err => {
                console.warn(err)
            })
        },
        navigateToAdminOperations({ dispatch }) {
            dispatch('onBeforeNavigate')

            Router.push({
                name: ROUTES.ADMIN_OPERATIONS
            }).catch(err => {
                console.warn(err)
            })
        },

        navigateBack({ state, dispatch }, { treatment, slide }) {
            switch (Router.currentRoute.name) {
                case ROUTES.WELL:
                    if (state.previousPageName === ROUTES.HOME_PAGE) {
                        dispatch('navigateHome')
                    } else {
                        dispatch('navigateToTreatment', {
                            patientId: treatment.patientId,
                            treatmentId: treatment._id,
                            slideId: slide._id,
                            view: state.currentView
                        })
                    }
                    return

                case ROUTES.TREATMENTS:
                    dispatch('navigateHome')
                    return

                case ROUTES.ADMIN_OPERATIONS:
                    dispatch('navigateHome')
                    return

                case ROUTES.HELP_CENTER:
                    dispatch('navigateHome')
                    return

                case ROUTES.HOME_PAGE:
                    return
            }
        },
        navigateHome({ dispatch }) {
            Router.push({ name: ROUTES.HOME_PAGE })

            dispatch('timelapse/resetSelectedItems', null, { root: true })
        },
        onBeforeNavigate({ rootState, commit }) {
            commit('setPreviousPageName', Router.currentRoute.name)
            rootState.timelapse.shareDialogOpened = null
        },
        resetSession({ state, commit }) {
            commit('currentTreatmentView', null)
            state.selectedHelpCenterTab = 'videos'
        }
    }
}
